var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTakenLeaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66651 5.93395L6.52888 5.05828L6.84117 5.37493L11.887 0.25L12.75 1.12504L6.84117 7.125L5.66651 5.93395ZM3.09117 5.37493L8.13698 0.25L8.99998 1.12504L3.09117 7.125L0.233521 4.21876L1.09652 3.34372L3.09117 5.37493Z",
    fill: "#007B23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakenLeaveIcon);
export default __webpack_public_path__ + "static/media/taken-leave-icon.efd00674c248a7f17114f59d8467471d.svg";
export { ForwardRef as ReactComponent };